import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CalendarEventService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CalendarEvent');
	}
	loadMySchedule(id: System.Guid) {
		if (!id) {
			id = '';
		}
		return this.myBaseService.loadAll(this.url + '/MySchedule/'+id);
	}
	loadCompanySchedule(): Observable<ePM.Logic.CalendarEvent[]> {
		return this.myBaseService.loadAll(this.url +'/CompanySchedule');
	}
	loadHolidays(): Observable<ePM.Logic.CalendarEvent[]> {
		return this.myBaseService.loadAll(this.url + '/Holidays');
	}

	save(tempItem: ECI.Basic.ObjectBase, type: string): Observable<ePM.Logic.CalendarEvent> {
		if (!type) {
			type = 'all';
		}
		return this.myBaseService.save(tempItem, this.url + '?type=' + type);
	}
	saveSchedule(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.CalendarEvent> {
		return this.myBaseService.save(tempItem, this.url + '/Schedule');
	}
	savePersonSchedule(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.CalendarEvent> {
		return this.myBaseService.save(tempItem, this.url + '/PersonSchedule');
	}
	deleteItem(id: System.Guid, deleteType: string, start: string): Observable<boolean> {
		if (!deleteType) {
			deleteType = '';
		}
		var deleteURL: string = '?type=' + deleteType;
		if (start) {
			deleteURL = deleteURL + '&start=' + new Date(start).toISOString();
		}
		return this.myBaseService.deleteWithParams(id, this.url, deleteURL);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.CalendarEvent> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.CalendarEvent> {
		return this.myBaseService.get(id, this.url);
	}
	search(calIDs: System.Guid[], peopleID: System.Guid[], start: Date, finish: Date, tasks: boolean, bdays: boolean): Observable<ePM.Logic.PublicFullCalendarEvent[]> {
		var searchObject = {
			LeavePeopleIDs: peopleID,
			CalendarIDs: calIDs,
			DateStart: start,
			DateFinish: finish,
            TaskShows: tasks,
            ShowAnniversaries: bdays
		}
		return this.myBaseService.post(searchObject, this.url + '/Search');
	}
}
